import React, { useState } from 'react'
import { RunCommandProps } from './RunCommand.types'
import { useRunCommand } from '../hooks'
import { SettingsButton } from '../atoms'

export const RunCommand: React.FC<RunCommandProps> = ({
  command,
  prefix = 'Run',
  hideButton = false,
  btnRef = undefined
}) => {
  const { runCommand } = useRunCommand()
  
  return <SettingsButton
    btnRef={btnRef}
    mainButtonStyle={hideButton ? { display: 'none' } : { }}
    onClick={() => {
      runCommand(command)
    }}
    disabled={!runCommand} 
    label={`${prefix} ${typeof command === 'object' ? command.name : command}`} />
}

export default RunCommand